<template>
  <div class="RLayoutBox">
    <el-row :gutter="40">
      <el-col :span="7" class="PerTreeHeight">
        <el-button
          size="medium"
          style="display: block; margin: 0 auto; width: 76%"
          type="primary"
          icon="el-icon-plus"
          @click="add"
          >添加行政区划</el-button
        >
        <div class="PerLine"></div>
        <el-tree
          :data="treeData"
          :props="treeProps"
          node-key="GroupId"
          :expand-on-click-node="false"
          @node-click="edit"
        >
        </el-tree>
      </el-col>
      <el-col :span="17" style="padding: 0 16%">
        <div class="FromTitle">
          <div class="FromTitleBorder"></div>
          <div class="FromTitleText">添加行政区划</div>
        </div>
        <el-form
          ref="form"
          @submit.native.prevent
          :model="form"
          :rules="rules"
          status-icon
          label-position="right"
          label-width="80px"
        >
          <el-form-item label="上级" prop="GroupParent">
            <GroupTree
              :readonly="isEdit"
              :GroupFlag="GroupFlag"
              v-model="form.GroupParent"
              ref="parenttree"
            ></GroupTree>
          </el-form-item>
          <el-form-item label="编码" prop="GroupCode">
            <el-input
              v-model.trim="form.GroupCode"
              placeholder="编码"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="名称" prop="GroupName">
            <el-input
              v-model.trim="form.GroupName"
              placeholder="名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="顺序" prop="GroupOrder">
            <el-input
              v-model.number="form.GroupOrder"
              placeholder="顺序"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="Remark">
            <el-input
              v-model.trim="form.Remark"
              placeholder="描述"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="save">保存</el-button>
            <el-button type="danger" @click="remove" v-if="isEdit"
              >删除</el-button
            >
            <el-button type="canale" @click="resetForm">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: ["GroupFlag"],
  data() {
    return {
      treeProps: {
        label: "GroupName",
      },
      GroupList: [],
      form: {},
      rules: {
        GroupCode: [this.$g.validRequired, this.$g.validLen(16)],
        GroupName: [this.$g.validRequired, this.$g.validLen(32)],
        GroupOrder: [this.$g.validRequired, this.$g.validNumber],
        Remark: [this.$g.validLen(32)],
      },
    };
  },
  computed: {
    treeData() {
      return this.$g.listToTree(this.GroupList, "GroupId", "GroupParent");
    },
    isEdit() {
      if (this.form.GroupId) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$get("UGroupinfo/GetList", {
        GroupFlag: this.GroupFlag,
      }).then((r) => {
        this.GroupList = r.Result;
      });
    },
    add() {
      this.resetFields();
      this.form = {};
    },
    edit(data) {
      this.resetFields();
      this.form = { ...data };
    },
    save() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return;
        }
        let values = { ...this.form };
        if (this.isEdit) {
          this.$put("UGroupinfo/Edit", values).then((r) => {
            this.$message.success("修改成功");
            this.resetFields();
            this.getData();
            this.$refs.parenttree.getData();
          });
        } else {
          values.GroupFlag = this.GroupFlag;
          this.$post("UGroupinfo/Add", values).then((r) => {
            this.$message.success("添加成功");
            this.resetFields();
            this.getData();
            this.$refs.parenttree.getData();
          });
        }
      });
    },
    remove() {
      if (this.form.children) {
        this.$message.error("有下级，不可删除！");
        return;
      }

      this.$confirm(`将删除${this.form.GroupName}, 是否继续?`, "提示信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "el-button--canale",
        type: "warning",
      })
        .then(() => {
          this.$delete("UGroupinfo/Delete", {
            GroupId: this.form.GroupId,
          }).then((r) => {
            this.$message.success("删除成功");
            this.resetFields();
            this.getData();
          });
        })
        .catch(() => {});
    },
    resetFields() {
      if (this.$refs["form"]) {
        this.form = {};
        this.$refs["form"].resetFields();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.RLayoutBox {
  height: calc(100vh - 114px) !important;
  overflow-y: auto;
  overflow-x: hidden;
}
.el-tree {
  height: calc(100vh - 190px - 6px);
  overflow-y: auto;
}
</style>